import React from "react";

import SkeletonLoader from "shrimmer/SkeletonLoader";

const FeedbackSurveyDetail = () => {
  return (
    <>
      <div className="_card">
        <div className="has_child">
          <SkeletonLoader type={"text"} height={23} width={80} bottomGap={8} />
          <SkeletonLoader type={"text"} height={20} width={180} />
        </div>
        <p>
          <SkeletonLoader type={"text"} height={20} width={800} bottomGap={8} />
        </p>
        <SkeletonLoader type={"text"} height={20} width={140} bottomGap={10} />
        <p>
          <SkeletonLoader
            type={"text"}
            count={2.75}
            height={20}
            width={800}
            bottomGap={8}
          />
        </p>
      </div>
    </>
  );
};

export default FeedbackSurveyDetail;